export default {
  'Your profile': 'Jouw profiel',
  Settings: 'Instellingen',
  Login: 'Inloggen',
  'Sign out': 'Uitloggen',
  Profile: 'Profiel',
  'Activate 2FA': '2FA activeren',
  'Disable 2FA': '2FA uitschakelen',
  Submit: 'Verzenden',
  Date: 'Datum',
  Calendar: 'Kalender',
  'Open popup': 'Open popup',
  'Choose value': 'Kies waarde',
  Send: 'Verstuur',
  'Your message has been sent. We will get in touch as soon as possible.':
    'Uw bericht is verstuurd. We nemen zo snel mogelijk contact met u op.',
  'Something went wrong sending your message. Please try again later.':
    'Er is iets fout gegaan met versturen van uw bericht. Probeer het later nog eens.',
  Dutch: 'Nederlands',
  English: 'Engels',
  'Always a perfect gift': 'Altijd een perfect cadeau',
  'View the assortment': 'Bekijk het assortiment',
  Cart: 'Winkelmand',
  Search: 'Zoeken',
  Brand: 'Merk',
  'Ordered before 15.00, shipped the same day':
    'Voor 15.00 besteld, dezelfde dag verstuurd',
  'Ordered before 15.00': 'Voor 15.00 besteld',
  'shipped the same day': 'dezelfde dag verstuurd',
  'Also digital gift cards': 'Ook digitale cadeaukaarten',
  'Digital gift cards': 'Digitale cadeaukaarten',
  'directly in your email': 'direct in je mail',
  'Pay easily with': 'Betaal eenvoudig met',
  'iDeal, credit card or invoice': 'iDeal, creditcard of op factuur',
  'Easy and secure payment': 'Eenvoudig & veilig betalen',
  'Delivery to desired address and time':
    'Levering op gewenst adres en tijdstip',
  'Delivery to desired': 'Levering op gewenst',
  'address and time': 'adres en tijdstip',
  'View all gift cards': 'Bekijk alle cadeaukaarten',
  'View gift card': 'Bekijk cadeaukaart',
  'View gift cards': 'Bekijk cadeaukaarten',
  Description: 'Omschrijving',
  'Product specifications': 'Productspecificatie',
  'Terms and conditions': 'Algemene voorwaarden',
  Occasions: 'Gelegenheden',
  Occasion: 'Gelegenheid',
  'Choose one of our 100+ gift cards': 'Kies één van onze 100+ giftcards',
  Categories: 'Categorieën',
  Filter: 'Filteren',
  'Fetching products.': 'Producten aan het ophalen.',
  'No gift cards found with these search criteria.':
    'Geen giftcards gevonden met deze zoekcriteria.',
  'Sadly we did not find any giftcards with these search criteria, take a look at some other giftcards':
    'Helaas hebben we geen giftcards gevonden met die criteria, bekijk hieronder de andere opties',
  'Most chosen gift cards.': 'Meest gekozen giftcards.',
  'Add to cart': 'Toevoegen aan winkelmand',
  'Choose your amount': 'Kies je waarde',
  'Custom amount': 'Eigen bedrag',
  Or: 'Of',
  'choose a custom amount': 'kies je eigen bedrag',
  Quantity: 'Aantal',
  'Business order': 'Zakelijk bestellen',
  'Choose your shipping method': 'Kies je verzendmethode',
  'Continue shopping': 'Ga door met winkelen',
  'By post': 'Per post',
  'By mail': 'Per post',
  'By email': 'Per email',
  Value: 'Waarde',
  'Order number': 'Ordernummer',
  'Order as': 'Bestellen als',
  'Order now': 'Bestel nu',
  Consumer: 'Particulier',
  Company: 'Zakelijk',
  'Company information': 'Bedrijfsinformatie',
  'Company name': 'Bedrijfsnaam',
  'Tax number': 'Btw-nummer',
  'KVK number': 'KvK-nummer',
  'Shipping information': 'Verzendgegevens',
  'Billing address': 'Factuuradres',
  Street: 'Straat',
  'House number': 'Huisnummer',
  Addition: 'Toevoeging',
  'Zip code': 'Postcode',
  City: 'Plaats',
  'Send gift cards to a different address':
    'Stuur giftcards naar afwijkend adres',
  'Your information': 'Jouw informatie',
  'First name': 'Voornaam',
  'Last name': 'Achternaam',
  'Phone number': 'Telefoonnummer',
  'Email address': 'E-mailadres',
  'Send gift cards to a different email address':
    'Verstuur giftcards naar afwijkend e-mailadres',
  'Create account': 'Account aanmaken',
  Password: 'Wachtwoord',
  'Confirm password': 'Herhaal wachtwoord',
  'Add a personal message (max 150 characters incl. spaces)':
    'Voeg een persoonlijke boodschap toe (max. 150 tekens incl. spaties)',
  Message: 'Boodschap',
  Amount: 'Waarde',
  Subtotal: 'Subtotaal',
  Shipping: 'Verzendkosten',
  Total: 'Totaal',
  'I agree to the ': 'Ik ga akkoord met de ',
  'terms and conditions': 'algemene voorwaarden',
  'Place order': 'Afrekenen',
  Checkout: 'Afrekenen',
  checkout: 'afrekenen',
  'Log in to autocomplete your information':
    'Log in om je informatie automatisch aan te vullen',
  Tax: 'Btw',
  'Continue to checkout': 'Verder met bestellen',
  Price: 'Prijs',
  'Forgot password': 'Wachtwoord vergeten',
  'A reset link has been sent to the email address.':
    'Er is een reset link gestuurd naar het e-mailadres.',
  'Something went wrong while requesting the password reset.':
    'Er is iets fout gegaan tijdens het aanvragen van de wachtwoord reset.',
  'Your password has been reset.': 'Uw wachtwoord is opnieuw ingesteld.',
  'Something went wrong while resetting the password.':
    'Er is iets misgegaan tijdens het resetten van het wachtwoord.',
  'Search for': 'Zoek op',
  'Occasion type': 'Type gelegenheid',
  'Person type': 'Type persoon',
  Oops: 'Oeps',
  'This page doesn\'t exist': 'Deze pagina bestaat niet',
  'Back to home': 'Terug naar homepagina',
  Voornaam: 'Voornaam',
  Achternaam: 'Achternaam',
  'E-mailadres': 'E-mailadres',
  Telefoonnummer: 'Telefoonnummer',
  Bericht: 'Bericht',
  'Desired shipping date': 'Gewenste verzenddatum',
  'Gift cards': 'Cadeaukaarten',
  'Thanks for your order!': 'Bedankt voor je bestelling!',
  'We will get started with your order right away':
    'We gaan gelijk aan de slag met je bestelling',
  'Order more gift cards': 'Meer cadeaukaarten bestellen',
  Menu: 'Menu',
  Order: 'Bestelling',
  Orders: 'Bestellingen',
  'Close menu': 'Sluit menu',
  'Something went wrong while placing your order. Please try again later.':
    'Er is iets fout gegaan tijdens het plaatsen van je bestelling. Probeer het later nog eens.',
  'Shipping method': 'Verzendmethode',
  'There is nothing in the shopping cart yet! Click here to add something!':
    'Er ligt nog niks in de winkelmand! Klik hier om iets toe te voegen!',
  'Apply filters': 'Filters toepassen',
  'View cart': 'Bekijk winkelwagen',
  'Product has been added to cart!': 'Product is toegevoegd aan winkelwagen!',
  'You must accept the terms and conditions to continue.':
    'Je dient de voorwaarden te accepteren om door te kunnen gaan.',
  'Gewenste cadeaukaart': 'Gewenste cadeaukaart',
  'Aantal gewenste cadeaukaarten': 'Aantal gewenste cadeaukaarten',
  'Bijzonderheden/opmerkingen': 'Bijzonderheden/opmerkingen',
  'Form has been submitted.': 'Formulier is verzonden.',
  'Something went wrong while submitting the form. Try again later.':
    'Er is iets misgegaan bij het verzenden van het formulier. Probeer het later opnieuw.',
  'Repeat email address': 'E-mailadres herhalen',
  'For both physical and digital products':
    'Voor zowel fysieke als digitale producten',
  'Frequently asked questions': 'Veelgestelde vragen',
  'E-mailadres herhalen': 'E-mailadres herhalen',
  'Activate account': 'Account activeren',
  'The password has been changed successfully, you are being redirected to the login page.':
    'Het wachtwoord is succesvol ingesteld, je wordt nu doorgestuurd naar de inlogpagina.',
  'Activating your account...': 'Account aan het activeren...',
  'Something went wrong while activating your account. Try again later.':
    'Er is iets fout gegaan tijdens het activeren van je account. Probeer het later nog eens.',
  'Your account has been activated. You will be redirected to the login page.':
    'Je account is geactiveerd. Je wordt nu doorgestuurd naar de inlogpagina.',
  Hide: 'Verbergen',
  Show: 'Tonen',
  Processing: 'In behandeling',
  Canceled: 'Geannuleerd',
  Completed: 'Afgerond',
  'Order date': 'Bestelling datum',
  'Shipping cost': 'Verzendkosten',
  'Payment method': 'Betaalmethode',
  'Payment status': 'Betalingsstatus',
  'There has been an error': 'Er is een fout opgetreden',
  'New Password': 'Nieuw wachtwoord',
  'Confirm new password': 'Herhaal nieuw wachtwoord',
  'Change email address': 'E-mailadres wijzigen',
  'Change password': 'Wachtwoord wijzigen',
  'Save changes': 'Wijzigingen opslaan',
  Email: 'E-mailadres',
  Cancel: 'Annuleren',
  'Login information': 'Inloggegevens',
  'Personal information': 'Persoonlijke data',
  'Good evening': 'Goedenavond',
  'Good afternoon': 'Goedemiddag',
  'Good morning': 'Goedemorgen',
  'Good night': 'Goedenacht',
  'Fields marked with (*) are required.':
    'Velden gemarkeerd met (*) zijn verplicht.',
  'Only available digitally': 'Alleen digitaal verkrijgbaar',
  'Request quote': 'Offerte aanvragen',
  'New password': 'Nieuw wachtwoord',
  'Successfully changed your login information':
    'Je inloggegevens zijn gewijzigd',
  Click: 'Klik',
  here: 'hier',
  'to check your cards balance': 'om je kaartsaldo te controleren',
  Product: 'Product',
  'Your order': 'Dit heb je besteld',
  'You paid with': 'Je hebt betaald met',
  'VAT is not applicable on most gift cards. A VAT rate of 21% applies to shipping costs.': 'Op de meeste cadeaukaarten is geen BTW van toepassing. Voor verzendkosten geldt een btw-tarief van 21%.',
  'Download invoice': 'Factuur downloaden',
  'The requested invoice is not (yet) available.': 'De opgevraagde factuur is (nog) niet beschikbaar.',
  Home: 'Home',
  Address: 'Adresgegevens',
  'Cost centre': 'Kostenplaats',
  'Do you already have an account?': 'Heb je al een account?',
  'Don\'t have an account yet? You can easily create this during': 'Heb je nog geen account? Je kan deze eenvoudig aanmaken tijdens het',
  'Read less': 'Lees minder',
  'Read more': 'Lees meer',
  'Choose one of our many well-known gift cards': 'Kies een van onze vele bekende gift cards',
  'An unknown error occurred. Please try again.': 'Er is een onbekende fout opgetreden. Probeer het later nog eens.',
  'The payment was canceled. Please try again.': 'De betaling is geannuleerd. Probeer het later nog eens.',
  'The payment failed. Please try again.': 'De betaling is mislukt. Probeer het later nog eens.',
  'label.delivery-date-delay': 'Wegens enorme drukte bij de post en pakketdiensten, kunnen wij helaas geen volgende dag levering garanderen voor fysieke kaarten. Houd rekening met meerdere dagen levertijd voor fysieke cadeaukaarten. Digitale cadeaukaarten worden binnen enkele minuten geleverd.',
};
